module.exports = __webpack_public_path__ + "img/layers-three-01.b7b6f17b.svg";